import React from 'react';
import classNames from 'classnames';
import { Paragraph2 } from '@cian/ui-kit';

import styles from './Description.css';

interface IDescriptionProps {
  promoted: boolean;
  text: string;
  lines?: number;
}

export const CSS_LINE_HEIGHT = 20;

export const Description = React.forwardRef(
  ({ text, lines, promoted }: IDescriptionProps, ref: React.Ref<HTMLDivElement>) => {
    const inlineStyles = React.useMemo(
      () =>
        lines
          ? {
              maxHeight: lines * CSS_LINE_HEIGHT,
              WebkitLineClamp: lines,
            }
          : {},
      [lines],
    );

    return (
      <div className={styles['cont']} ref={ref}>
        <div className={classNames(styles['description'], promoted && styles['promoted'])} style={inlineStyles}>
          <Paragraph2>{text}</Paragraph2>
        </div>
      </div>
    );
  },
);
